import React from "react";
import gs from "gstyles";
import { APP_STORE_URL, PLAY_STORE_URL } from "utils/constant";

interface AppStoreButtonsProps {
  /** Kích thước nút: lg = 180x52 (section/404), md = 150x44 (modal) */
  size?: "md" | "lg";
  className?: string;
}

const SIZES = {
  lg: { width: "180px", height: "52px" },
  md: { width: "150px", height: "44px" },
};

/** Cặp nút Google Play + App Store, link lấy từ utils/constant */
const AppStoreButtons: React.FC<AppStoreButtonsProps> = ({
  size = "lg",
  className = "",
}) => {
  const dims = SIZES[size];
  return (
    <div className={`flex gap-3 items-center justify-center flex-wrap ${className}`}>
      <a
        href={PLAY_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="block"
        aria-label="Google Play"
      >
        {gs.icons({ name: "googleplay", ...dims })}
      </a>
      <a
        href={APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="block"
        aria-label="App Store"
      >
        {gs.icons({ name: "appstore", ...dims })}
      </a>
    </div>
  );
};

export default AppStoreButtons;
